import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { ProductTypes } from "../../../public/landingPage/components/productTypes";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutline";
import { getPastOrderListAsync } from "../../../../../app/slices/pastOrderSlice/PastOrderSlice";
import {
  getPastOrderDataDetailsAsync,
  getBillDetailsAsync,
  paymentCustomOrderCheckoutAsync,
} from "../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Footer } from "../../../../layouts/footer";
import { useMediaQuery } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import CakeIcon from "@mui/icons-material/Cake";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ImageIcon from "@mui/icons-material/Image";
import DownloadIcon from "@mui/icons-material/Download";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { PAYU_URL } from "../../../../../api/payu/Api";
import Chip from "@mui/material/Chip";
import {
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomCakeDetails from "./CustomCakeDetails";
// const sectionCard = {
//   background: "#fff",
//   border: "1px solid #e6e6e6",
//   borderRadius: "18px",
//   padding: "24px",
//   boxShadow: "0 12px 24px rgba(15, 23, 42, 0.06)",
// };
const sectionCard = {
  background: "#ffffff",
  borderRadius: 18,
  padding: 28,
  border: "1px solid #e7e7e7",
  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
};
const iconBox = {
  width: "42px",
  height: "42px",
  borderRadius: "50%",
  background: "#f7f9fb",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const OrderConfirmationNew = () => {
   const isMobileScreen = useMediaQuery("(max-width:765px)");
  const isIPadMini = useMediaQuery("(min-width:768px) and (max-width:834px)");
   const [localconfirmedOrder, setlocalconfirmedOrder] = useState({}) as any;
   const [deliveryLink, setDeliveryLink] = useState<string>("");
   const navigate = useNavigate();
   const dispatch = useAppDispatch();
   const { profileData }: any = useAppSelector((state) => state.ProfileState);
   const [isLoading, setIsLoading] = useState(false);
   const [downloading, setDownloading] = useState(false);
   const [progress, setProgress] = useState(0);
   const [uuidFromPastOrder, setuuidFromPastOrder] = useState();
   const [availablePaymentModes, setAvailablePaymentModes] = useState([]) as any;
   const [selectedPaymentModeId, setSelectedPaymentModeId] = useState<
     number | null
   >(null);
   const [previewOpen, setPreviewOpen] = useState(false);
   const [previewImage, setPreviewImage] = useState("");
   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);
 
   useEffect(() => {
     setIsLoading(true);
     dispatch(getPastOrderListAsync()).then((response: any) => {
       if (response?.payload?.status === 200) {
         setuuidFromPastOrder(response?.payload?.data?.orders?.[0]?.uuid);
       }
     });
   }, []);
   useEffect(() => {
     const orderUUID = localStorage.getItem("order_uuid");
     if (orderUUID) {
       setIsLoading(true);
       dispatch(getPastOrderDataDetailsAsync(orderUUID)).then(
         (response: any) => {
           if (response?.payload?.status === 200) {
             setlocalconfirmedOrder(response?.payload?.data?.order_details);
             setDeliveryLink(response?.payload?.data?.delivery_link || "");
              setAvailablePaymentModes(
               response?.payload?.data?.available_payment_modes
             );
             if (response?.payload?.data?.available_payment_modes?.length > 0) {
               // prefer the first mode if none selected yet
               if (!selectedPaymentModeId)
                 setSelectedPaymentModeId(
                   Number(response?.payload?.data?.available_payment_modes[0].id)
                 );
             }
             setIsLoading(false);
           }
         }
       );
     } else if (!orderUUID && uuidFromPastOrder) {
       setIsLoading(true);
       dispatch(getPastOrderDataDetailsAsync(uuidFromPastOrder)).then(
         (response: any) => {
           if (response?.payload?.status === 200) {
             setlocalconfirmedOrder(response?.payload?.data?.order_details);
             setDeliveryLink(response?.payload?.data?.delivery_link || "");
             setAvailablePaymentModes(
               response?.payload?.data?.available_payment_modes
             );
             if (response?.payload?.data?.available_payment_modes?.length > 0) {
               // prefer the first mode if none selected yet
               if (!selectedPaymentModeId)
                 setSelectedPaymentModeId(
                   Number(response?.payload?.data?.available_payment_modes[0].id)
                 );
             }
             setIsLoading(false);
           }
         }
       );
     } else {
       const localconfirmedOrder2 = JSON.parse(
         localStorage.getItem("orderDetails") as any
       );
       setlocalconfirmedOrder(localconfirmedOrder2);
     }
   }, [, uuidFromPastOrder]);
 
const buildFullAddress = (address: any) => {
    if (!address) return "";

    const addressParts = [
      address.address_1,
      address.address_2,
      address.flat_no,
      address.landmark,
      address.area,
      address.address_3,
      address.street,
    ].filter((part) => part && String(part).trim() !== "");

    const deduped = Array.from(new Set(addressParts.map((part) => String(part).trim())));
    return deduped.join(", ");
  };

  const convertTimeTo12HourFormat = (time: string): string => {
     if (!time) {
       return ""; // Return a fallback string if time is undefined or falsy
     }
 
     const [hours, minutes] = time.split(":").map(Number);
     const isPM = hours >= 12;
     const formattedHours = hours % 12 || 12; // Converts 00:00 to 12:00 for midnight
     const formattedMinutes = minutes?.toString().padStart(2, "0");
     const period = isPM ? "PM" : "AM";
 
     return `${formattedHours}:${formattedMinutes} ${period}`;
   };
 
   const convertDateToMMDDYYYY = (date: string): string => {
     let year, month, day;
     if (date) {
       [year, month, day] = date.split("-");
     }
     return year && month && day ? `${month}/${day}/${year}` : "";
   };
 const formatPickupTime = (date?: string, time?: string) => {
  if (!date || !time) return "-";

  const [hours, minutes] = time.split(":").map(Number);

  const d = new Date(date);
  d.setHours(hours, minutes, 0);

  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
   const formatDateToMMDDYYYY = (date: string): string => {
     if (date !== "Invalid Date") {
       const d = new Date(date);
 
       const month = String(d?.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
       const day = String(d?.getDate()).padStart(2, "0");
       const year = d?.getFullYear();
 
       const hours24 = d?.getHours();
       const minutes = String(d?.getMinutes()).padStart(2, "0");
 
       // Convert to 12-hour format
       const isPM = hours24 >= 12;
       const hours12 = hours24 % 12 || 12; // 12 is for midnight and noon
       const period = isPM ? "PM" : "AM";
 
       return `${month}/${day}/${year} ${hours12}:${minutes} ${period}`;
     } else return "";
   };
 
   const isCodPayment = () => {
     const paymentFields = [
       localconfirmedOrder?.payment_type,
       localconfirmedOrder?.payment_method,
       localconfirmedOrder?.payment_mode,
       localconfirmedOrder?.mode_name,
       localconfirmedOrder?.payment?.method,
     ];
 
     return paymentFields.some(
       (field) =>
         typeof field === "string" && field.toLowerCase().includes("cod")
     );
   };
 
   const getTotalLabel = () => {
     if (!isCodPayment()) return "Total";
     return localconfirmedOrder?.order_status === "Delivered" || localconfirmedOrder?.order_status === "Collected" ? "Paid" : "To Pay";
   };
 
   const convertTimeFormat = (createdDate: any | undefined) => {
     if (createdDate && createdDate !== "Not Provided") {
       const date = new Date(createdDate);
 
       const day = date.getDate();
       const month = date.toUTCString().split(" ")[2];
       const year = date.getFullYear().toString().slice(-2);
       const hours = date.getHours();
       const minutes = date.getMinutes();
       const isPM = hours >= 12;
       const formattedHours = hours % 12 || 12;
       const formattedMinutes = minutes.toString().padStart(2, "0");
       const period = isPM ? "PM" : "AM";
 
       return `${day}th ${month} ${year} - ${formattedHours}:${formattedMinutes}${period}`;
     }
     return "";
   };
 
   const handleCheckoutClick = async (orderId: any) => {
     try {
       const payload: any = {
         order_id: orderId,
         delivery_mode: selectedPaymentModeId,
       };
 
       const response: any = await dispatch(
         paymentCustomOrderCheckoutAsync(payload)
       );
 
       console.log("Custom Order Checkout API Response:", response);
      
 
       if (selectedPaymentModeId === 1 && response?.payload?.data) {
         dispatch(
           showSnackbar({
             message: "Order placed successfully with COD",
             severity: "success",
             autoHide: 3000,
           })
         );
         window.location.reload();
         navigate("/order-confirmation");
       } else if (
         response?.payload?.data?.status === 1 &&
         response?.payload?.data?.params &&
         response?.payload?.data?.params?.key
       ) {
         // Handler for new JSON response format with payu_url and params
         console.log("PayU params found, redirecting...", response?.payload?.data?.params);
         redirectToPayU(
           response?.payload?.data?.params,
           response?.payload?.data?.payu_url || PAYU_URL
         );
       } else {
         dispatch(
           showSnackbar({
             message: "Failed to initiate PayU payment",
             severity: "error",
           })
         );
       }
     } catch (err) {
       dispatch(
         showSnackbar({ message: "Something went wrong.", severity: "error" })
       );
     }
   };
 
   const orderDate = new Date(localconfirmedOrder?.created_date);
   
   const handleDownload = () => {
     const orderId = localconfirmedOrder?.order_ID;
     if (!orderId || downloading) return; // ⛔ Prevent multiple clicks
 
     setDownloading(true); // 🚀 Lock
     setProgress(0);
 
     // Simulate progress bar while waiting for API
     const interval = setInterval(() => {
       setProgress((oldProgress) => {
         if (oldProgress >= 90) return oldProgress; // stop at 90%, final 100% after success
         return oldProgress + 10;
       });
     }, 300);
 
     dispatch(getBillDetailsAsync(orderId))
       .then((response: any) => {
         if (response?.payload?.status === 200) {
           const blob = new Blob([response.payload.data], {
             type: "application/pdf",
           });
           const url = window.URL.createObjectURL(blob);
 
           // ✅ Open in new tab
           window.open(url, "_blank");
 
           // ✅ Optional force download
           const link = document.createElement("a");
           link.href = url;
           link.setAttribute("download", `Bill-${response.meta.arg}.pdf`);
           document.body.appendChild(link);
           link.click();
           link.remove();
        } else {
          dispatch(
            showSnackbar({
              message: "Bill is not available for this order yet.",
              severity: "error",
              autoHide: 3000,
            })
          );
         }
         setDownloading(false); // 🔓 Unlock
       })
       .finally(() => {
         clearInterval(interval);
         setProgress(100); // ✅ complete
         setTimeout(() => {
           setDownloading(false);
           setProgress(0);
         }, 500); // small delay before resetting
       })
       .catch(() => {
         setDownloading(false); // 🔓 Unlock on error too
         setProgress(0);
       });
   };
  // Helper function to create and submit PayU form
   const redirectToPayU = (params: any, payuUrl: string) => {
     const form = document.createElement("form");
     form.method = "POST";
     form.action = payuUrl;
 
     Object.entries(params).forEach(([key, value]) => {
       const input = document.createElement("input");
       input.type = "hidden";
       input.name = key;
       input.value = String(value ?? "");
       form.appendChild(input);
     });
 
     document.body.appendChild(form);
     form.submit();
   };
 const paymentMode =
   localconfirmedOrder?.mode_name ||
   localconfirmedOrder?.payment_mode ||
   localconfirmedOrder?.payment_method ||
   localconfirmedOrder?.payment_type ||
   "";
 
 const isCOD = paymentMode.toLowerCase().includes("cod");
const isLongDistanceOrder = localconfirmedOrder?.order_type === "Long Distance Orders";
console.log("localconfirmedOrder", localconfirmedOrder);
  if (isLoading) {
    return (
      <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </div>
    );
  }
const status = localconfirmedOrder?.order_status;
const isCustomOrder = localconfirmedOrder?.order_type === "Custom Orders";
const isPickup = localconfirmedOrder?.order_type === "Pick Up";
 
const firstCustomization =
  localconfirmedOrder?.order_data?.[0]?.customizations?.[0];

const hasOrderInfo =
  localconfirmedOrder?.some_one_else_order?.name ||
  localconfirmedOrder?.some_one_else_order?.phone_number ||
  localconfirmedOrder?.additional_info ||
  localconfirmedOrder?.mobile_number;

const hasCustomization =
  firstCustomization?.custom_note ||
  firstCustomization?.custom_image;
const imageUrl=`${process.env.REACT_APP_API_URL}${firstCustomization?.custom_image}`;
console.log("Img_url",imageUrl);
const isCompleted = (statuses: string[]) => statuses.includes(status);

const orderStatusTimeline = () => {
  if (status === "Failed") {
    return [
      {
        title: "Order Failed",
        success: true,
        date: "",
      },
    ];
  }

  if (status === "Cancelled") {
    return [
      {
        title: "Order is Pending",
        success: true,
        date: formatDateToMMDDYYYY(orderDate?.toString()),
      },
      {
        title: "Order is Placed",
        success: true,
      },
      {
        title: "Order Accepted",
        success: true,
      },
      {
        title: "Order Cancelled",
        success: false,
        failure: true,
        date: "",
      },
    ];
  }

  const timeline: any[] = [];

  // Custom Orders
  if (isCustomOrder) {
    timeline.push(
      {
        title: "Enquiry Submitted",
        success: isCompleted([
          "Enquiry",
          "Contacted",
          "Bill Created",
          "Confirmed",
          "Viewed",
          "Order Packed",
          "Delivery Assigned",
          "Dispatching",
          "Despatched",
          "Delivered",
          "Collected",
        ]),
        date: formatDateToMMDDYYYY(orderDate?.toString()),
      },
      {
        title: "Contacted",
        success: isCompleted([
          "Contacted",
          "Bill Created",
          "Confirmed",
          "Viewed",
          "Order Packed",
          "Delivery Assigned",
          "Dispatching",
          "Despatched",
          "Delivered",
          "Collected",
        ]),
      },
      {
        title: "Proforma Invoice Created",
        success: isCompleted([
          "Bill Created",
          "Confirmed",
          "Viewed",
          "Order Packed",
          "Delivery Assigned",
          "Dispatching",
          "Despatched",
          "Delivered",
          "Collected",
        ]),
      }
    );
  } else {
    timeline.push({
      title: "Order is Pending",
      success: isCompleted([
        "New Order",
        "Confirmed",
        "Viewed",
        "Order Packed",
        "Delivery Assigned",
        "Dispatching",
        "Despatched",
        "Delivered",
        "Collected",
      ]),
      date: formatDateToMMDDYYYY(orderDate?.toString()),
    });
  }

  timeline.push(
    {
      title: "Order is Placed",
      success: isCompleted([
        "Confirmed",
        "Viewed",
        "Order Packed",
        "Delivery Assigned",
        "Dispatching",
        "Despatched",
        "Delivered",
        "Collected",
      ]),
    },
    {
      title: "Order Accepted",
      success: isCompleted([
        "Viewed",
        "Order Packed",
        "Delivery Assigned",
        "Dispatching",
        "Despatched",
        "Delivered",
        "Collected",
      ]),
    },
    {
      title: "Order is Packed",
      success: isCompleted([
        "Order Packed",
        "Delivery Assigned",
        "Dispatching",
        "Despatched",
        "Delivered",
        "Collected",
      ]),
    }
  );

  if (isPickup) {
    timeline.push({
      title: "Order Collected",
      success: status === "Collected",
      date: `${convertDateToMMDDYYYY(
        localconfirmedOrder?.delivery_slot_date
      )} ${convertTimeTo12HourFormat(
        localconfirmedOrder?.delivery_slot_time
      )}`,
    });
  } else {
    timeline.push(
      {
        title: "Delivery Assigned",
        success: isCompleted([
          "Delivery Assigned",
          "Dispatching",
          "Despatched",
          "Delivered",
        ]),
      },
      {
        title: "Order Delivered",
        success: status === "Delivered",
        date: `${convertDateToMMDDYYYY(
          localconfirmedOrder?.delivery_slot_date
        )} ${convertTimeTo12HourFormat(
          localconfirmedOrder?.delivery_slot_time
        )}`,
      }
    );
  }

  return timeline;
};

// items and scroll handling for order items list
const items = localconfirmedOrder?.order_data || [];
const isScrollableItems = (items?.length || 0) > 3;
const itemsContainerStyle: any = isScrollableItems
  ? { maxHeight: isMobileScreen ? 260 : 320, overflowY: "auto", paddingRight: 8 }
  : {};
  return (
    <>
      <ResponsiveAppBar />
      <ProductTypes />
      <main
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "24px 16px",
          fontFamily: "Albert Sans, sans-serif",
        }}
      >
       {isLoading ? (
  <div
    style={{
      minHeight: "45vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress />
  </div>
) : (
  <section
    style={{
      background:
        localconfirmedOrder?.order_status === "Failed" ||
        localconfirmedOrder?.order_status === "Cancelled"
          ? "#fff4f4"
          : "#eaf7f2",
      borderRadius: 20,
      padding: 32,
      marginBottom: 24,
      textAlign: "center",
      // border:
        // localconfirmedOrder?.order_status === "Failed" ||
        // localconfirmedOrder?.order_status === "Cancelled"
        //   ? "1px solid #ffd6d6"
        //   : "1px solid #d8efe5",
    }}
  >
    {/* Icon */}
    <div
      style={{
        width: 72,
        height: 72,
        margin: "0 auto 0px",
        borderRadius: "50%",
        background:
          localconfirmedOrder?.order_status === "Failed" ||
          localconfirmedOrder?.order_status === "Cancelled"
            ? "#ffe5e5"
            : "#d6f0e7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {localconfirmedOrder?.order_status === "Failed" ||
      localconfirmedOrder?.order_status === "Cancelled" ? (
        <img
          src="/shopnow/images/status-fail.svg"
          width={36}
          alt="failed"
        />
      ) : (
        <CheckCircleIcon
          style={{
            color: "#0a6f47",
            fontSize: 36,
          }}
        />
      )}
    </div>

    {/* Failed */}
    {localconfirmedOrder?.order_status === "Failed" ? (
      <>
        <h1
          style={{
            margin: 0,
            fontSize: 30,
            color: "#c62828",
            fontWeight: 700,
          }}
        >
          Order Failed
        </h1>

        <p
          style={{
            marginTop: 16,
            color: "#666",
            lineHeight: 1.7,
            fontSize: 16,
          }}
        >
          Your order has failed.
          <br />
          Please contact the shop directly to initiate a refund.
        </p>

        {localconfirmedOrder?.order_ID && (
          <p
            style={{
              // marginTop: 10,
              fontWeight: 700,
              color: "#222",
            }}
          >
            Order ID : {localconfirmedOrder.order_ID}
          </p>
        )}
      </>
    ) : localconfirmedOrder?.order_status === "Cancelled" ? (
      <>
        {/* Cancelled */}
        <h1
          style={{
            margin: 0,
            fontSize: 30,
            color: "#c62828",
            fontWeight: 700,
          }}
        >
          Order Cancelled
        </h1>

        <p
          style={{
            // marginTop: 16,
            color: "#666",
            lineHeight: 1.7,
            fontSize: 16,
          }}
        >
          Your order has been cancelled.
          <br />
          Please contact the shop if you need further details.
        </p>

        {localconfirmedOrder?.order_ID && (
          <p
            style={{
              marginTop: 10,
              fontWeight: 700,
              color: "#222",
            }}
          >
            Order ID : {localconfirmedOrder.order_ID}
          </p>
        )}
      </>
    ) : localconfirmedOrder?.order_type === "Custom Orders" &&
      !localconfirmedOrder?.grand_total ? (
      <>
        {/* Custom Order Submitted */}
        <h1
          style={{
            margin: 0,
            fontSize: 30,
            color: "#0b5450",
            fontWeight: 700,
          }}
        >
          Custom Cake Request Submitted!
        </h1>

        <p
          style={{
            // marginTop: 16,
            color: "#5f7c80",
            lineHeight: 1.7,
            fontSize: 16,
          }}
        >
          Our team is reviewing your request.
          <br />
          You will hear from us shortly.
        </p>
      </>
    ) : (
      <>
        {/* Success */}
        <h1
          style={{
            margin: 0,
            fontSize: 32,
            color: "#0b5450",
            fontWeight: 700,
          }}
        >
          Confirmed
        </h1>

        <p
          style={{
            // margin: "12px 0 6px",
            fontSize: 16,
            color: "#5f7c80",
          }}
        >
          Thank You!
        </p>

        <p
          style={{
            margin: 0,
            fontSize: 16,
            color: "#5f7c80",
          }}
        >
          Your Order has been Placed. Order Id :{" "}
          <strong>{localconfirmedOrder?.order_ID}</strong>
        </p>
      </>
    )}
  </section>
)}

        <div
  style={{
    display: "grid",
    gridTemplateColumns: isMobileScreen ? "1fr" : "2fr 1fr",
    gap: 24,
  }}
>
  {/* ================= Left Section ================= */}
  <div style={sectionCard}>
    {/* Shop / Pickup Details */}
    <div
      style={{
        display: isMobileScreen ? "block" : "grid",
        gridTemplateColumns: isMobileScreen ? undefined : `1fr ${ localconfirmedOrder?.order_type !== "Pick Up" && isIPadMini ? "200px" : "280px"}`,
        gap: 24,
        alignItems: "start",
        gridAutoRows: "min-content",
      }}
    >
      <div style={{ minWidth: 0 }}>
        {/* Order ID & Created Time - Custom Orders only */}
        {/* {localconfirmedOrder?.order_type === "Custom Orders" && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <strong>{localconfirmedOrder?.order_ID}</strong>

              <span>{convertTimeFormat(localconfirmedOrder?.created_date)}</span>
            </div>

            <hr
              style={{
                borderStyle: "dashed",
                borderColor: "#ddd",
                marginBottom: 20,
              }}
            />
          </>
        )} */}

        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontSize: 12,
              textTransform: "uppercase",
              letterSpacing: ".15em",
              color: "#3f5b6a",
              fontWeight: 700,
              marginBottom: 8,
            }}
          >
            {localconfirmedOrder?.order_type === "Long Distance Orders"
              ? "Pickup Unit"
              : "Shop"}
          </div>

          <div
            style={{
              color: "#0c2735",
              fontSize: 22,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.02em",
            }}
          >
            {localconfirmedOrder?.order_type === "Long Distance Orders"
              ? localconfirmedOrder?.pu_name
              : localconfirmedOrder?.shop_name}
          </div>

          <div
            style={{
              color: "#5f717d",
              marginTop: 6,
              fontSize: 14,
            }}
          >
            {localconfirmedOrder?.order_type === "Long Distance Orders"
              ? localconfirmedOrder?.pu_location
              : localconfirmedOrder?.shop_location}
          </div>
        </div>

        {/* Mobile: show contact card near shop name above address/phone */}
        {isMobileScreen && (
          <div
            style={{
              background: "#f3faf5",
              borderRadius: 18,
              padding: 14,
              border: "1px solid #d7ede4",
              marginBottom: 12,
            }}
          >
            <div
              style={{
                ...iconBox,
                background: "#e67e22",
                color: "#fff",
                marginBottom: 8,
              }}
            >
              <PhoneIcon />
            </div>

            <p
              style={{
                margin: "0 0 6px",
                color: "#5a6b70",
                fontSize: 14,
                lineHeight: 1.45,
              }}
            >
              For Urgent Enquiries, Contact us at
            </p>

            <p
              style={{
                margin: 0,
                fontWeight: 700,
                color: "#122433",
                fontSize: 16,
              }}
            >
              +91{" "}
              {localconfirmedOrder?.order_type === "Long Distance Orders"
                ? localconfirmedOrder?.pu_contact
                : localconfirmedOrder?.shop_contact}
            </p>

            {deliveryLink && (
              <button
                onClick={() => window.open(deliveryLink, "_blank")}
                style={{
                  marginTop: 12,
                  width: "100%",
                  border: "none",
                  background: "#0c5672",
                  color: "#fff",
                  padding: "8px",
                  borderRadius: 10,
                  cursor: "pointer",
                }}
              >
                View Location
              </button>
            )}
          </div>
        )}

         <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
            gap: 24,
          }}
        >
          {/* Address */}
          {localconfirmedOrder?.order_type !== "Pick Up" && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "#ef8d22",
                  marginBottom: 8,
                }}
              >
                <LocationOnIcon fontSize="small" sx={{ color: "#ef8d22" }}/>

                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#ef8d22",
                    textTransform: "uppercase",
                    letterSpacing: "0.02em",
                  }}
                >
                  {localconfirmedOrder?.address_type
                    ?.toLowerCase()
                    .replace(/\b\w/g, (c: any) => c.toUpperCase())}
                </span>
              </div>

              <p
                style={{
                  margin: 0,
                  fontWeight: 700,
                  color: "#122f3b",
                  lineHeight: 1.6,
                }}
              >
                {buildFullAddress(localconfirmedOrder)}
              </p>
            </div>
          )}

          {/* Phone */}
          <div  style={localconfirmedOrder?.order_type !== "Pick Up" ? { marginTop: 0 } : { marginTop: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                color: "#ef8d22",
                marginBottom: 8,
              }}
            >
              <PhoneIcon fontSize="small" sx={{ color: "#ef8d22" }}/>

              <span
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#ef8d22",
                  textTransform: "uppercase",
                  letterSpacing: "0.02em",
                }}
              >
                Phone
              </span>
            </div>

            <p
              style={{
                margin: 0,
                fontWeight: 700,
                color: "#122f3b",
              }}
            >
              {profileData?.data?.phone_number}
            </p>
          </div>
        </div>

        {/* Ordered for someone else */}
        {/* {localconfirmedOrder?.some_one_else_order?.name && (
          <>
            <hr
              style={{
                margin: "24px 0",
                borderStyle: "dashed",
              }}
            />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
                gap: 20,
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 8,
                  }}
                >
                  <PersonIcon fontSize="small" />

                  <span>Ordered For</span>
                </div>

                <strong>
                  {localconfirmedOrder?.some_one_else_order?.name}
                </strong>
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 8,
                  }}
                >
                  <PhoneIcon fontSize="small" />

                  <span>Phone</span>
                </div>

                <strong>
                  {localconfirmedOrder?.some_one_else_order?.phone_number}
                </strong>
              </div>
            </div>
          </>
        )} */}

        {/* Alternate Contact */}
        {/* {localconfirmedOrder?.additional_info && (
          <>
            <hr
              style={{
                margin: "24px 0",
                borderStyle: "dashed",
              }}
            />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
                gap: 20,
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 8,
                  }}
                >
                  <PersonIcon fontSize="small" />

                  <span>Alternate Contact</span>
                </div>

                <strong>{localconfirmedOrder?.additional_info}</strong>
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 8,
                  }}
                >
                  <PhoneIcon fontSize="small" />

                  <span>Phone</span>
                </div>

                <strong>{localconfirmedOrder?.mobile_number}</strong>
              </div>
            </div>
          </>
        )} */}
      </div>

      {/* Contact Card (hidden on mobile because it's rendered above) */}
      <div
        style={{
          display: isMobileScreen ? "none" : "block",
          width: "100%",
          minWidth: 0,
          background: "#f3faf5",
          borderRadius: 18,
          padding: 18,
          border: "1px solid #d7ede4",
          boxSizing: "border-box",
          alignSelf: "start",
          position: "relative",
          zIndex: 1,
          marginLeft: isIPadMini ? 18 : 0,
        }}
      >
        <div
          style={{
            ...iconBox,
            background: "#e67e22",
            color: "#fff",
            marginBottom: 12,
          }}
        >
          <PhoneIcon />
        </div>

        <p
          style={{
            margin: "0 0 6px",
            color: "#5a6b70",
            fontSize: 14,
            lineHeight: 1.45,
          }}
        >
          For Urgent Enquiries, Contact us at
        </p>

        <p
          style={{
            margin: 0,
            fontWeight: 700,
            color: "#122433",
            fontSize: 16,
          }}
        >
          +91{" "}
          {localconfirmedOrder?.order_type === "Long Distance Orders"
            ? localconfirmedOrder?.pu_contact
            : localconfirmedOrder?.shop_contact}
        </p>

        {deliveryLink && (
          <button
            onClick={() => window.open(deliveryLink, "_blank")}
            style={{
              marginTop: 18,
              width: "100%",
              border: "none",
              background: "#0c5672",
              color: "#fff",
              padding: "10px",
              borderRadius: 10,
              cursor: "pointer",
            }}
          >
            View Location
          </button>
        )}
      </div>
    </div>

    <hr
      style={{
        margin: localconfirmedOrder?.order_type !== "Pick Up" ? "28px 0" : "10px 0",
        borderStyle: "dashed",
        borderColor: "#d4cece",
      }}
    />

    {/* Bottom Information */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobileScreen ? "1fr" : "1.2fr 0.8fr",
        gap: 24,
        alignItems: "start",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <CalendarMonthIcon fontSize="small" sx={{ color: "#ef8d22" }}/>
          <span
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#ef8d22",
              // textTransform: "uppercase",
              letterSpacing: "0.02em",
            }}
          >
            Ordered On
          </span>
        </div>

        <strong
          style={{
            display: "block",
            color: "#101f2a",
            fontSize: 16,
          }}
        >
          {formatDateToMMDDYYYY(orderDate?.toString())}
        </strong>

        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            marginTop: 20,
            marginBottom: 8,
          }}
        >
          <LocalShippingIcon fontSize="small" sx={{ color: "#ef8d22" }}/>
          <span
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#ef8d22",
              // textTransform: "uppercase",
              letterSpacing: "0.02em",
            }}
          >
            Delivery Mode
          </span>
        </div>

        <strong
          style={{
            display: "block",
            color: "#101f2a",
            fontSize: 16,
          }}
        >
          {localconfirmedOrder?.order_type === "Pick Up"
            ? "Pickup"
            : localconfirmedOrder?.order_type === "Custom Orders"
            ? "Custom Order"
            : "Home Delivery"}
        </strong>
      </div>

      <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      color: "#ef8d22",
    }}
  >
    <ScheduleIcon fontSize="small" sx={{ color: "#ef8d22" }} />

    <span
      style={{
        fontSize: 14,
        fontWeight: 700,
        color: "#ef8d22",
      }}
    >
      {localconfirmedOrder?.order_type === "Pick Up" || localconfirmedOrder?.delivery_type === "Pick Up"
        ? "Pickup Time"
        : "Expected Delivery"}
    </span>
  </div>

  <div
    style={{
      fontSize: 16,
      fontWeight: 700,
      color: "#122433",
      lineHeight: 1.5,
      wordBreak: "break-word",
    }}
  >
    {isLongDistanceOrder
      ? "Order delivery expected within one week"
      : localconfirmedOrder?.order_type === "Pick Up" || localconfirmedOrder?.delivery_type === "Pick Up"
      ? formatPickupTime(
          localconfirmedOrder?.delivery_slot_date,
          localconfirmedOrder?.delivery_slot_time
        )
      : localconfirmedOrder?.delivery_time}
  </div>
</div>
    </div>
  </div>
{/* order summary */}
         {localconfirmedOrder?.grand_total && (
  <aside style={sectionCard}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 20,
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: 24,
          fontWeight: 700,
          color: "#0c5672",
        }}
      >
        Bill Details
      </h3>

      {downloading ? (
        <CircularProgress variant="determinate" value={progress} size={26} />
      ) : (
        <DownloadIcon
          onClick={handleDownload}
          style={{
            cursor: "pointer",
            color: "#040404",
          }}
        />
      )}
    </div>

    <div style={{ display: "grid", gap: 16 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#5f7c80",
          fontSize: 14,
        }}
      >
        <span>Item Total</span>
        <span style={{ color: "#101f2a", fontWeight: 700 }}>
          ₹{localconfirmedOrder?.sub_total ?? 0}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#5f7c80",
          fontSize: 14,
        }}
      >
        <span>Delivery Fee</span>
        <span style={{ color: "#101f2a", fontWeight: 700 }}>
          ₹{localconfirmedOrder?.delivery_charges ?? 0}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#5f7c80",
          fontSize: 14,
        }}
      >
        <span>Discount</span>
        <span style={{ color: "#101f2a", fontWeight: 700 }}>
          ₹{localconfirmedOrder?.discount ?? 0}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#5f7c80",
          fontSize: 14,
        }}
      >
        <span>GST</span>
        <span style={{ color: "#101f2a", fontWeight: 700 }}>
          ₹
          {localconfirmedOrder?.taxes_and_charges
            ? Number(localconfirmedOrder.taxes_and_charges).toFixed(2)
            : "0.00"}
        </span>
      </div>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: isCOD ? "#b26a00" : "#1565c0",
          fontWeight: 700,
        }}
      >
        <span>Payment Mode</span>
        <span>{paymentMode}</span>
      </div> */}

      <hr style={{ borderColor: "#d4cece" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: 700,
          color: "#122f3b",
          fontSize: 18,
        }}
      >
        <span>{getTotalLabel()}</span>
        <span>₹{localconfirmedOrder?.grand_total ?? 0}</span>
      </div>

    

      {localconfirmedOrder?.payment_mode && (
        <>
          <hr style={{ borderColor: "#d4cece" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
      >
        <span style={{ color: "#5f7c80" }}>Paid By</span>

        <Chip
          label={isCOD ? "COD" : "ONLINE PAYMENT"}
          sx={{
            borderRadius: "18px",
            fontWeight: 700,
            bgcolor: isCOD ? "#FFF4E5" : "#E8F5FF",
            color: isCOD ? "#B26A00" : "#1565C0",
            border: `1px solid ${isCOD ? "#FFD699" : "#90CAF9"}`,
          }}
        />
      </div></>)}

      {localconfirmedOrder?.order_status === "Bill Created" && (
        <>
          <hr  style={{ borderColor: "#d4cece" }}/>

          <div style={{ fontWeight: 600 }}>
            Choose Payment Method
          </div>

          <FormControl component="fieldset">
            <RadioGroup
              value={
                selectedPaymentModeId !== null
                  ? String(selectedPaymentModeId)
                  : ""
              }
              onChange={(e) =>
                setSelectedPaymentModeId(Number(e.target.value))
              }
            >
              {(availablePaymentModes || []).map((mode: any) => (
                <FormControlLabel
                  key={mode.id}
                  value={String(mode.id)}
                  control={<Radio />}
                  label={mode.mode_name}
                />
              ))}
            </RadioGroup>
          </FormControl>

          <button
            onClick={() =>
              handleCheckoutClick(localconfirmedOrder?.order_ID)
            }
            style={{
              width: "100%",
              padding: "12px",
              border: "none",
              borderRadius: 10,
              background: "#114c5a",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {selectedPaymentModeId === 1
              ? "Confirm Order"
              : "Proceed to Pay"}
          </button>
        </>
      )}
    </div>
  </aside>
)}
        </div>

        {localconfirmedOrder?.order_data?.length > 0 && (<div style={{ marginTop: 24, ...sectionCard }}>
  <h2
    style={{
      margin: 0,
      fontSize: 24,
      fontWeight: 700,
      color: "#0c5672",
      marginBottom: 20,
    }}
  >
    Order Items
  </h2>

  <div style={{ display: "grid", gap: 20, ...itemsContainerStyle }}>
    {localconfirmedOrder?.order_data?.length > 0 ? (
      localconfirmedOrder.order_data.map((item: any, index: number) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 16,
            paddingBottom:
              index !== localconfirmedOrder.order_data.length - 1 ? 20 : 0,
            borderBottom:
              index !== localconfirmedOrder.order_data.length - 1
                ? "1px solid #ebeff1"
                : "none",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 18,
                color: "#222",
                textTransform: "uppercase",
              }}
            >
              {item?.sku_name || item?.name || "Item"}
            </div>

            <div
              style={{
                marginTop: 6,
                color: "#6d7d84",
                fontSize: 16,
              }}
            >
              Qty : {item?.quantity ?? 1}
            </div>

            {item?.customizations?.length > 0 && (
              <div
                style={{
                  marginTop: 12,
                  color: "#777",
                  fontSize: 14,
                }}
              >
                {item.customizations.map((custom: any, i: number) => (
                  <div key={i}>• {custom.name}</div>
                ))}
              </div>
            )}
          </div>

          <div
            style={{
              minWidth: 100,
              textAlign: "right",
              fontWeight: 700,
              fontSize: 18,
              color: "#222",
            }}
          >
            ₹{item?.price ?? 0}
          </div>
        </div>
      ))
    ) : (
      <p style={{ margin: 0, color: "#5f7c80" }}>
        No items found for this order.
      </p>
    )}
  </div>
</div>)}
{/*customization and gifting*/}
{hasOrderInfo && (
  <div style={{ marginTop: 24, ...sectionCard }}>
    <h2
      style={{
        margin: 0,
        fontSize: 24,
        fontWeight: 700,
        color: "#0c5672",
        marginBottom: 24,
      }}
    >
      Order Information
    </h2>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
        gap: 24,
      }}
    >
      {localconfirmedOrder?.some_one_else_order?.name && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 8,
            }}
          >
            <PersonIcon sx={{ color: "#ef8d22" }} />
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#48545b",
              }}
            >
              Ordered For
            </span>
          </div>

          <div
            style={{
              fontWeight: 700,
              color: "#122f3b",
            }}
          >
            {localconfirmedOrder.some_one_else_order.name}
          </div>

          {localconfirmedOrder?.some_one_else_order?.phone_number && (
            <div
              style={{
                marginTop: 6,
                color: "#6c7d7d",
              }}
            >
              {localconfirmedOrder.some_one_else_order.phone_number}
            </div>
          )}
        </div>
      )}

      {localconfirmedOrder?.additional_info && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 8,
            }}
          >
            <ContactPhoneIcon sx={{ color: "#ef8d22" }} />
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#48545b",
              }}
            >
              Alternate Contact
            </span>
          </div>

          <div
            style={{
              fontWeight: 700,
              color: "#122f3b",
            }}
          >
            {localconfirmedOrder.additional_info}
          </div>

          {localconfirmedOrder?.mobile_number && (
            <div
              style={{
                marginTop: 6,
                color: "#6c7d7d",
              }}
            >
              {localconfirmedOrder.mobile_number}
            </div>
          )}
        </div>
      )}
    </div>
  </div>
)}
{hasCustomization && (
  <div style={{ marginTop: 24, ...sectionCard }}>
    <h2
      style={{
        margin: 0,
        fontSize: 24,
        fontWeight: 700,
        color: "#0c5672",
        marginBottom: 24,
      }}
    >
      Cake Customization
    </h2>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
        gap: 24,
      }}
    >
      {firstCustomization?.custom_note && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 8,
            }}
          >
            <CakeIcon sx={{ color: "#ef8d22" }} />

            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#48545b",
              }}
            >
              Message on Cake
            </span>
          </div>

          <div
            style={{
              fontWeight: 700,
              color: "#122f3b",
            }}
          >
            {firstCustomization.custom_note}
          </div>
        </div>
      )}

      {imageUrl && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 8,
            }}
          >
            <ImageIcon sx={{ color: "#ef8d22" }} />

            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#48545b",
              }}
            >
              Design Reference
            </span>
          </div>

        
  <img
    src={imageUrl}
    alt="Cake Design"
    onClick={() => {setPreviewImage(imageUrl);setPreviewOpen(true)}}
    style={{
      width: "90px",
      height: "90px",
      objectFit: "cover",
      borderRadius: "10px",
      border: "1px solid #ddd",
      cursor: "pointer",
      transition: "0.3s",
    }}
    // onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
    // onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
  />

        </div>
      )}
    </div>
  </div>
)}
         {/* <div style={{ marginTop: 24, ...sectionCard }}>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "#0c5672", marginBottom: 20 }}>Customization & Gifting</h2>
          <div style={{ display: "grid", gap: 20 }}>
            <div style={{ display: "grid", gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr", gap: 24 }}>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#dd7b1a", marginBottom: 8 }}>
                  <CakeIcon style={{ fontSize: 20 }} />
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#48545b" }}>Message on Cake</span>
                </div>
                <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#122f3b" }}>
                  {localconfirmedOrder?.message || "-"}
                </p>
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#dd7b1a", marginBottom: 8 }}>
                  <EditNoteIcon style={{ fontSize: 20 }} />
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#48545b" }}>Request on Cake</span>
                </div>
                <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#122f3b" }}>
                  {localconfirmedOrder?.description || "-"}
                </p>
              </div>
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#dd7b1a", marginBottom: 8 }}>
                <ImageIcon style={{ fontSize: 20 }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: "#48545b" }}>Design Reference</span>
              </div>
              <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                <div style={{ width: 64, height: 64, borderRadius: 14, background: "#f7f9fb", border: "1px solid #e6e6e6", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <ImageIcon style={{ color: "#9ca3af", fontSize: 28 }} />
                </div>
                <span style={{ color: "#6c7d7d", fontSize: 14 }}>{localconfirmedOrder?.reference_image || "Reference_image_01.jpg"}</span>
              </div>
            </div>
          </div>

        </div>  */}
        {localconfirmedOrder?.order_type === "Custom Orders" && (
            <CustomCakeDetails  order={localconfirmedOrder}
    isMobileScreen={isMobileScreen}/>
  // <div style={{ marginTop: 24, ...sectionCard }}>
  //   <h2
  //     style={{
  //       margin: 0,
  //       fontSize: 24,
  //       fontWeight: 700,
  //       color: "#0c5672",
  //       marginBottom: 20,
  //     }}
  //   >
  //     Custom Cake Details
  //   </h2>

  //   <div style={{ display: "grid", gap: 20 }}>
  //     <div
  //       style={{
  //         display: "grid",
  //         gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
  //         gap: 24,
  //       }}
  //     >
  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <CakeIcon style={{ fontSize: 20 }} sx={{ color: "#ef8d22" }}/>
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Product Selected
  //           </span>
  //         </div>

  //         <p
  //           style={{
  //             margin: 0,
  //             fontSize: 16,
  //             fontWeight: 700,
  //             color: "#122f3b",
  //           }}
  //         >
  //           {localconfirmedOrder?.custom_product?.item_name || "-"}
  //         </p>
  //       </div>

  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <EditNoteIcon style={{ fontSize: 20 }} />
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Request on Cake
  //           </span>
  //         </div>

  //         <p
  //           style={{
  //             margin: 0,
  //             fontSize: 16,
  //             fontWeight: 700,
  //             color: "#122f3b",
  //           }}
  //         >
  //           {localconfirmedOrder?.description || "-"}
  //         </p>
  //       </div>
  //     </div>

  //     <div
  //       style={{
  //         display: "grid",
  //         gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
  //         gap: 24,
  //       }}
  //     >
  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <CakeIcon style={{ fontSize: 20 }} />
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Message on Cake
  //           </span>
  //         </div>

  //         <p
  //           style={{
  //             margin: 0,
  //             fontSize: 16,
  //             fontWeight: 700,
  //             color: "#122f3b",
  //           }}
  //         >
  //           {localconfirmedOrder?.message || "-"}
  //         </p>
  //       </div>

  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <ImageIcon style={{ fontSize: 20 }} />
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Design Reference
  //           </span>
  //         </div>

  //         {localconfirmedOrder?.custom_image ? (
  //           <img
  //             src={localconfirmedOrder.custom_image}
  //             alt="Custom Design"
  //             style={{
  //               width: 120,
  //               height: 120,
  //               objectFit: "cover",
  //               borderRadius: 12,
  //               border: "1px solid #e6e6e6",
  //             }}
  //           />
  //         ) : (
  //           <p
  //             style={{
  //               margin: 0,
  //               fontSize: 16,
  //               color: "#6c7d7d",
  //             }}
  //           >
  //             No Image
  //           </p>
  //         )}
  //       </div>
  //     </div>

  //     <hr style={{ margin: "24px 0", borderColor: "#e6e6e6" }} />

  //     <div
  //       style={{
  //         display: "grid",
  //         gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
  //         gap: 24,
  //       }}
  //     >
  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <CakeIcon style={{ fontSize: 20 }} />
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Quantity
  //           </span>
  //         </div>

  //         <p
  //           style={{
  //             margin: 0,
  //             fontSize: 16,
  //             fontWeight: 700,
  //             color: "#122f3b",
  //           }}
  //         >
  //           {localconfirmedOrder?.quantity} {localconfirmedOrder?.quantity_unit}
  //         </p>
  //       </div>

  //       <div>
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 10,
  //             color: "#dd7b1a",
  //             marginBottom: 8,
  //           }}
  //         >
  //           <LocalShippingIcon style={{ fontSize: 20 }} />
  //           <span
  //             style={{
  //               fontSize: 14,
  //               fontWeight: 600,
  //               color: "#48545b",
  //             }}
  //           >
  //             Delivery Type
  //           </span>
  //         </div>

  //         <p
  //           style={{
  //             margin: 0,
  //             fontSize: 16,
  //             fontWeight: 700,
  //             color: "#122f3b",
  //           }}
  //         >
  //           {localconfirmedOrder?.delivery_type || "-"}
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // </div>
//   <div style={{ marginTop: 24, ...sectionCard }}>
//   <h2
//     style={{
//       margin: 0,
//       fontSize: 24,
//       fontWeight: 700,
//       color: "#0c5672",
//       marginBottom: 18,
//     }}
//   >
//     Custom Cake Details
//   </h2>

//   {/* Top Row */}
//   <div
//     style={{
//       display: "grid",
//       gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
//       gap: 30,
//       alignItems: "start",
//     }}
//   >
//     {/* Left */}
//     <div style={{ display: "grid", gap: 22 }}>
//       <div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//             marginBottom: 8,
//           }}
//         >
//           <CakeIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//           <span
//             style={{
//               fontSize: 14,
//               fontWeight: 600,
//               color: "#48545b",
//             }}
//           >
//             Product Selected
//           </span>
//         </div>

//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: 17,
//             color: "#122f3b",
//           }}
//         >
//           {localconfirmedOrder?.custom_product?.item_name || "-"}
//         </div>
//       </div>

//       <div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//             marginBottom: 8,
//           }}
//         >
//           <CakeIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//           <span
//             style={{
//               fontSize: 14,
//               fontWeight: 600,
//               color: "#48545b",
//             }}
//           >
//             Message on Cake
//           </span>
//         </div>

//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: 17,
//             color: "#122f3b",
//           }}
//         >
//           {localconfirmedOrder?.message || "-"}
//         </div>
//       </div>
//     </div>

//     {/* Right */}
//     <div style={{ display: "grid", gap: 22 }}>
//       <div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//             marginBottom: 8,
//           }}
//         >
//           <EditNoteIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//           <span
//             style={{
//               fontSize: 14,
//               fontWeight: 600,
//               color: "#48545b",
//             }}
//           >
//             Request on Cake
//           </span>
//         </div>

//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: 17,
//             color: "#122f3b",
//           }}
//         >
//           {localconfirmedOrder?.description || "-"}
//         </div>
//       </div>

      
//       <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           marginBottom: 8,
//         }}
//       >
//         <LocalShippingIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//         <span
//           style={{
//             fontSize: 14,
//             fontWeight: 600,
//             color: "#48545b",
//           }}
//         >
//           Delivery Type
//         </span>
//       </div>

//       <div
//         style={{
//           fontWeight: 700,
//           fontSize: 17,
//           color: "#122f3b",
//         }}
//       >
//         {localconfirmedOrder?.delivery_type || "-"}
//       </div>
//     </div>
//     </div>
//   </div>

//   <hr
//     style={{
//       margin: "15px 0",
//       border: "none",
//       borderTop: "1px solid #f0f0f0",
//     }}
//   />

//   {/* Bottom */}
//   <div
//     style={{
//       display: "grid",
//       gridTemplateColumns: isMobileScreen ? "1fr" : "1fr 1fr",
//       gap: 30,
//     }}
//   >
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           marginBottom: 8,
//         }}
//       >
//         <CakeIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//         <span
//           style={{
//             fontSize: 14,
//             fontWeight: 600,
//             color: "#48545b",
//           }}
//         >
//           Quantity
//         </span>
//       </div>

//       <div
//         style={{
//           fontWeight: 700,
//           fontSize: 17,
//           color: "#122f3b",
//         }}
//       >
//         {localconfirmedOrder?.quantity} {localconfirmedOrder?.quantity_unit}
//       </div>
//     </div>

//     <div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//             marginBottom: 10,
//           }}
//         >
//           <ImageIcon sx={{ color: "#ef8d22", fontSize: 20 }} />

//           <span
//             style={{
//               fontSize: 14,
//               fontWeight: 600,
//               color: "#48545b",
//             }}
//           >
//             Design Reference
//           </span>
//         </div>

//         {localconfirmedOrder?.custom_image ? (
//           <img
//             src={localconfirmedOrder.custom_image}
//             alt="Custom Design"
//             onClick={() => {
//               setPreviewImage(localconfirmedOrder.custom_image);
//               setPreviewOpen(true);
//             }}
//             style={{
//               width: 90,
//               height: 90,
//               objectFit: "cover",
//               borderRadius: 12,
//               border: "1px solid #e6e6e6",
//               cursor: "pointer",
//               transition: "0.25s",
//             }}
//           />
//         ) : (
//           <span style={{ color: "#777" }}>No Image</span>
//         )}
//       </div>
//   </div>
// </div>
)}
{/*orderstatusbar*/}
       <div style={{ marginTop: 24, ...sectionCard }}>
  <h2
    style={{
      margin: 0,
      fontSize: 24,
      fontWeight: 700,
      color: "#0c5672",
      // marginBottom: 24,
    }}
  >
    Order Status
  </h2>

 <div >
  {orderStatusTimeline().map((item, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        gap: 14,
        position: "relative",
        paddingBottom:
          index !== orderStatusTimeline().length - 1 ? 12 : 0, // Reduced space
      }}
    >
      {/* Timeline */}
      <div
        style={{
          width: 28,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        {/* Circle */}
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            background: "#fff",
            border: `3px solid ${
              item.failure ? "#d32f2f" : item.success ? "#31c57b" : "#cfcfcf"
            }`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: item.failure ? "#d32f2f" : item.success ? "#31c57b" : "#9e9e9e",
            }}
          />
        </div>

        {/* Dotted Connector */}
        {index !== orderStatusTimeline().length - 1 && (
          <div
            style={{
              flex: 1,
              borderLeft: "2px dotted #d6d6d6",
              marginTop: 4,
              minHeight: 36, // Smaller connector
            }}
          />
        )}
      </div>

      {/* Text */}
      <div style={{ paddingTop: 1 }}>
        <div
          style={{
            fontWeight: 700,
            fontSize: 16,
            color: "#122f3b",
            lineHeight: "20px",
          }}
        >
          {item.title}
        </div>

        {item.date && (
          <div
            style={{
              color: "#777",
              fontSize: 14,
              marginTop: 4,
            }}
          >
            {item.date}
          </div>
        )}
      </div>
    </div>
  ))}
</div>
</div>
      </main>
      <Footer />
     <Dialog
      open={previewOpen}
      onClose={() => setPreviewOpen(false)}
      maxWidth="md"
    >
      <IconButton
        onClick={() => setPreviewOpen(false)}
        sx={{
          // position: "absolute",
          // top: 8,
          // right: 8,
          
          // zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
    
      <DialogContent
        sx={{
          p: 1,
          
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={previewImage}
          alt="Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "80vh",
            borderRadius: 8,
          }}
        />
      </DialogContent>
    </Dialog>
    </>
  );
};
